<template>
  <nav
    aria-label="Navigation principale"
    class="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
    style="padding-bottom: env(safe-area-inset-bottom)"
  >
    <ul class="grid grid-cols-5 h-14">
      <li v-for="tab in tabs" :key="tab.key" class="flex">
        <component
          :is="tab.kind === 'link' ? 'router-link' : 'button'"
          :to="tab.kind === 'link' ? tab.to : undefined"
          :type="tab.kind === 'button' ? 'button' : undefined"
          :class="[
            'relative flex-1 flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors',
            isActive(tab) ? 'text-brand-600' : 'text-slate-500 hover:text-slate-700',
          ]"
          @click="onTabClick(tab)"
        >
          <span
            v-if="isActive(tab)"
            aria-hidden="true"
            class="absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-8 rounded-full bg-brand-500"
          />
          <span class="relative">
            <component :is="tab.icon" class="h-5 w-5" :stroke-width="isActive(tab) ? 2.4 : 2" />
            <span
              v-if="tab.key === 'cart' && cartCount > 0"
              class="absolute -top-1.5 -right-2 h-4 min-w-[16px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center ring-2 ring-white"
            >{{ cartCount > 99 ? '99+' : cartCount }}</span>
          </span>
          <span class="leading-none">{{ tab.label }}</span>
        </component>
      </li>
    </ul>

    <category-menu
      v-if="showCategoryMenuDialog"
      :showDialog="showCategoryMenuDialog"
      @update:showDialog="showCategoryMenuDialog = $event"
      @close="showCategoryMenuDialog = false"
    />
  </nav>
</template>

<script>
import { defineComponent, h } from 'vue';
import CategoryMenu from '@/components/category/categoryMenu.vue';

const Icon = (paths, viewBox = '0 0 24 24') => defineComponent({
  props: { strokeWidth: { type: [Number, String], default: 2 }, class: { type: String, default: '' } },
  setup(props) {
    return () => h('svg', {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': props.strokeWidth,
      class: props.class || '',
    }, paths.map((d) => h('path', { 'stroke-linecap': 'round', 'stroke-linejoin': 'round', d })));
  },
});

const HomeIcon = Icon(['M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6']);
const CategoriesIcon = Icon(['M4 6h16M4 12h16M4 18h16']);
const HeartIcon = Icon(['M4.318 6.318a4.5 4.5 0 016.364 0L12 7.636l1.318-1.318a4.5 4.5 0 116.364 6.364L12 20.364l-7.682-7.682a4.5 4.5 0 010-6.364z']);
const UserIcon = Icon(['M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z']);
const CartIcon = Icon(['M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2 8h13m-5-4a2 2 0 100 4 2 2 0 000-4zm-7 0a2 2 0 100 4 2 2 0 000-4z']);

export default {
  name: 'BottomNav',
  components: { CategoryMenu },
  data() {
    return {
      showCategoryMenuDialog: false,
    };
  },
  computed: {
    cartCount() {
      const achats = this.$store.state.achats;
      return Array.isArray(achats) ? achats.length : 0;
    },
    isLoggedIn() {
      return !!(this.$store.state.client || this.$store.state.clientId);
    },
    tabs() {
      return [
        { key: 'home',       kind: 'link',   to: '/',               label: 'Accueil',     icon: HomeIcon,       match: (p) => p === '/' },
        { key: 'categories', kind: 'button', label: 'Catégories', icon: CategoriesIcon, match: () => this.showCategoryMenuDialog },
        { key: 'lists',      kind: 'link',   to: this.isLoggedIn ? '/account/lists' : '/logineC', label: 'Listes', icon: HeartIcon, match: (p) => p.startsWith('/account/lists') || p.startsWith('/liste') },
        { key: 'account',    kind: 'link',   to: this.isLoggedIn ? '/account/dashboard' : '/logineC', label: 'Compte', icon: UserIcon, match: (p) => p.startsWith('/account') && !p.startsWith('/account/lists') },
        { key: 'cart',       kind: 'link',   to: '/cart',           label: 'Panier',      icon: CartIcon,       match: (p) => p.startsWith('/cart') },
      ];
    },
  },
  methods: {
    isActive(tab) {
      return tab.match ? !!tab.match(this.$route.fullPath) : false;
    },
    onTabClick(tab) {
      if (tab.kind === 'button' && tab.key === 'categories') {
        this.showCategoryMenuDialog = true;
      }
    },
  },
};
</script>
